import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

import { useFilterController } from '../../../../application/useFilterController';
import { CostFinanceBody } from './CostFinanceBody';
import { parsePropertyTaxesValue } from '../../../../domain/mappers/propertyTaxesMapper';
import { parsePricePerSqftValue } from '../../../../domain/mappers/pricePerSqftMapper';
import { Range } from '../../../../domain/FilterTypes';

export const CostFinanceDrawerSection = () => {
  const { propertyTaxesRange, setPropertyTaxesRange, pricePerSqftRange, setPricePerSqftRange } = useFilterController();
  const [ isMobileOpen, setIsMobileOpen ] = useState<boolean>(false);

  const handlePropertyTaxesChange = (type: 'min' | 'max', value: string) => {
    const parsedValue = parsePropertyTaxesValue(value);
    const currentRange = propertyTaxesRange || Range.create(null, null);
    const newRange = type === 'min'
      ? currentRange.withMin(parsedValue)
      : currentRange.withMax(parsedValue);
    setPropertyTaxesRange(newRange);
  };

  const handlePricePerSqftChange = (type: 'min' | 'max', value: string) => {
    const parsedValue = parsePricePerSqftValue(value);
    const currentRange = pricePerSqftRange || Range.create(null, null);
    const minValue = type === 'min' ? parsedValue : currentRange.min;
    const maxValue = type === 'max' ? parsedValue : currentRange.max;
    setPricePerSqftRange(minValue, maxValue);
  };

  const handleAcceptedFinancingChange = (value: string) => {
    // TODO: Add acceptedFinancing to filter store and backend if needed
    console.log('Accepted financing:', value);
  };

  return (
    <div className="p-4">
      <div className="mb-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold">Property Taxes</h3>
          <button
            type="button"
            className="sm:hidden inline-flex items-center rounded border border-gray-300 p-1 text-gray-600"
            onClick={() => setIsMobileOpen((v) => !v)}
            aria-expanded={isMobileOpen}
            aria-controls="cost-finance-body"
          >
            {isMobileOpen ? (
              <ChevronUpIcon className="h-5 w-5" />
            ) : (
              <ChevronDownIcon className="h-5 w-5" />
            )}
          </button>
        </div>
      </div>

      <div id="cost-finance-body" className={`${isMobileOpen ? 'block' : 'hidden'} sm:block`}>
        <CostFinanceBody
          propertyTaxes={propertyTaxesRange || Range.create(null, null)}
          pricePerSqft={pricePerSqftRange || Range.create(null, null)}
          acceptedFinancing="Select one"
          onPropertyTaxesChange={handlePropertyTaxesChange}
          onPricePerSqftChange={handlePricePerSqftChange}
          onAcceptedFinancingChange={handleAcceptedFinancingChange}
        />
      </div>
    </div>
  );
};
